<template>
  <div class="solution-content">
    <div class="common-title">
      <div class="common-title-content">
        方案概述
      </div>
    </div>
    <p class="solution-info">
      当前，信息技术和智能手段深度融入教育全过程，我国教育信息化已经迈进了全新阶段。将数字技术与校园教学、管理深度融合，能够实现学生安全、智慧教学、数字办公、智能管理的实质提升。
    </p>
    <div class="solution-des">
      <img src="@/assets/images/solution/img_zhxy.png" />
    </div>
    <div class="solution-main-function">
      <div class="common-title">
        <div class="common-title-content">
          主要功能
        </div>
      </div>
      <div class="solution-main-show">
        <div class="show-item" v-for="(item, index) in iconList" :key="index">
          <img :src="item.iconSrc" />
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
    <div class="solution-application-scene">
      <div class="common-title">
        <div class="common-title-content">
          应用场景
        </div>
      </div>
      <div class="show-scene-list">
        <div class="item" v-for="(item, index) in imgList" :key="index">
          <img :src="item.imgUrl" />
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "zhxy",
  data() {
    return {
      iconList: [
        {
          iconSrc: require("@/assets/images/solution/ico_xyaf.png"),
          text: "校园安防"
        },
        {
          iconSrc: require("@/assets/images/solution/ico_yqgk.png"),
          text: "疫情管控"
        },
        {
          iconSrc: require("@/assets/images/solution/ico_xyfxyj.png"),
          text: "风险预警"
        },
        {
          iconSrc: require("@/assets/images/solution/ico_xyyq.png"),
          text: "校园舆情"
        },
        {
          iconSrc: require("@/assets/images/solution/ico_kqtq.png"),
          text: "考勤通勤"
        }
      ],
      imgList: [
        {
          imgUrl: require("@/assets/images/solution/ssaq.png"),
          text: "师生安全"
        },
        {
          imgUrl: require("@/assets/images/solution/ktkq.png"),
          text: "课堂考勤"
        },
        {
          imgUrl: require("@/assets/images/solution/cggl.png"),
          text: "场馆管理"
        },
        {
          imgUrl: require("@/assets/images/solution/yxlx.png"),
          text: "迎新离校"
        }
      ]
    };
  }
};
</script>
